export default "__VITE_ASSET__D$SHgmnj__"